'use client'

import { Suspense } from 'react'
import { UserPortfolio } from 'src/app/(networks)/_ui/user-portfolio'

export const WagmiHeaderComponents: React.FC = () => {
  return (
    <Suspense>
      <UserPortfolio />
    </Suspense>
  )
}
